export default "__VITE_ASSET__BUjVuQxf__"